// @flow
export const LEGAL_INFO_WEBTHEO_ID = 'WEBTHEO';
export const LEGAL_INFO_THEO_ID = 'THEO';
export const LEGAL_INFO_SMS_ID = 'SMS_OPTIN';
export const LEGAL_INFO_EMAIL_ID = 'EMAIL_OPTIN';
export const LEGAL_INFO_MAIL_ID = 'MAIL_OPTIN';
export const LEGAL_INFO_FOSUN_ID = 'FOSUN_PARTNERS';
export const LEGAL_INFO_CGV_ID = 'CGV';
